module.exports = __webpack_public_path__ + "static/p-10 - Copy-0955d5e7ef8b7a9b681e3106d10edf25.jpg";